export const environment = {
    production: false,
    dev_api: true,
    name: 'devapi',
    apiUrl: 'https://tt.dev3.hillel.it',
    apiV2Url: 'https://tt.dev3.hillel.it/api-v2',
    socketUrl: 'https://tt.dev3.hillel.it',
    lmsUrl: 'https://lms.dev3.hillel.it',
    ttUrl: 'https://tt.dev3.hillel.it',
    siteUrl: 'https://videosite.dev0.hillel.it',
    googleAnalytics: 'UA-XXXXXXXXX-X',
    posthog_api_key: 'phc_DS7MP1O9eT4cGgH3lZwe5g9jUZxS3joCLGkXWetocrS',
    posthog_api_host: 'https://eu.posthog.com',
    map_box: {
        access_token:
            'pk.eyJ1IjoiZm9taW51YSIsImEiOiJja2dobmcwazQxam1uMnlzMWExdDlkbmM0In0.KcAv6MPuS1WKTxCV6xaOKg',
    },
    certificate_link: 'https://certificate.dev.ithillel.ua',
};
